import { render, staticRenderFns } from "./GuestRecord.vue?vue&type=template&id=64502034&scoped=true"
import script from "./GuestRecord.vue?vue&type=script&lang=js"
export * from "./GuestRecord.vue?vue&type=script&lang=js"
import style0 from "./GuestRecord.vue?vue&type=style&index=0&id=64502034&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64502034",
  null
  
)

export default component.exports